import type { ReactNode } from "react";

import { useCan } from "@/hooks";

interface CanProps {
  /** Bitta ruxsat yoki ro'yxat — ro'yxatda BITTASI yetarli (OR). */
  permission: string | string[];
  children: ReactNode;
  /** Ruxsat bo'lmaganda ko'rsatiladigan narsa. Standart holatda — hech nima. */
  fallback?: ReactNode;
}

/**
 * Ruxsatga qarab ko'rsatadigan o'ram.
 *
 * Tugmani `disabled` qilish o'rniga butunlay YASHIRADI: bosib
 * bo'lmaydigan tugma "menda huquq bo'lishi kerak edi" degan savol
 * tug'diradi, ko'rinmagan tugma esa savolsiz o'tadi.
 *
 * Bu — qulaylik, xavfsizlik emas. Haqiqiy cheklov backendda.
 */
export function Can({ permission, children, fallback = null }: CanProps) {
  const { can, canAny } = useCan();
  const allowed = Array.isArray(permission) ? canAny(permission) : can(permission);

  return <>{allowed ? children : fallback}</>;
}
